import React from 'react'
import { Helmet } from 'react-helmet-async'
import Header from './Header'
import Footer from './Footer'
import Layout from './Layout'
import Overlay from './Overlay'
import Lightbox from './Lightbox'

// Keep the generated HTML and the first browser render identical.
export const wrapPageElement = ({ element, props }) => {
  const siteUrl = process.env.GATSBY_SITE_LANGUAGE === 'it'
    ? 'https://soulvalley.it'
    : 'https://soulvalley.com'
  // Use the pathname so tracking parameters and preview hosts never become
  // the page's permanent Open Graph identity. Available during SSR as well.
  const pageUrl = new URL(props.location.pathname, siteUrl).href

  return (
    <>
      <Helmet>
        <meta property="og:url" content={pageUrl} />
      </Helmet>
      <Header location={props.location} />
      <Layout {...props}>{element}</Layout>
      <Overlay />
      <Lightbox />
      <Footer />
    </>
  )
}
